import * as React from "react";

function SvgIconawesomeCheck(props) {
  return (
    <svg width={18.774} height={14} {...props}>
      <path
        data-name="Icon awesome-check"
        d="M6.377 13.723l-6.1-6.1a.939.939 0 010-1.328L1.6 4.969a.939.939 0 011.328 0l4.11 4.11 8.8-8.8a.939.939 0 011.328 0L18.5 1.603a.939.939 0 010 1.328L7.7 13.723a.939.939 0 01-1.323 0z"
        fill="#1dd600"
      />
    </svg>
  );
}

export default SvgIconawesomeCheck;
